import React, { useState } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';
import SimplePDFViewer from '../components/SimplePDFViewer';
import Colors from '../constants/Colors';

export default function PDFViewerScreen() {
  // Using the local PDF file from assets
  const [hasReadToEnd, setHasReadToEnd] = useState(false);

  const handleEndReached = () => {
    setHasReadToEnd(true);
  };

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar style="auto" />
      <View style={styles.header}>
        <Text style={styles.headerText}>TERMS AND CONDITIONS</Text>
        {hasReadToEnd && <Text style={styles.readIndicator}>✓ Read</Text>}
      </View>
      <View style={styles.pdfContainer}>
        <SimplePDFViewer onEndReached={handleEndReached} />
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.light.hereworksBackground,
  },
  header: {
    padding: 16,
    backgroundColor: Colors.light.hereworksBlue500,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#fff',
  },
  pdfContainer: {
    flex: 1,
    padding: 8,
  },
  readIndicator: {
    color: '#4AFF91',
    fontWeight: 'bold',
    marginLeft: 10,
    fontSize: 16,
  },
});
